import { createContext } from "@compono/ui";
import { useApolloClient } from "@apollo/client";

export type ApolloClientsContext = {
  employerClient: ReturnType<typeof useApolloClient>;
  engageClient: ReturnType<typeof useApolloClient>;
  shortlysterClient: ReturnType<typeof useApolloClient>;
  trackyrClient: ReturnType<typeof useApolloClient>;
  /** The legacy `/graphql` route — the whole supergraph. */
  federationGatewayClient: ReturnType<typeof useApolloClient>;
  /** The tag-filtered `platform` contract; only `platformGraphql.ts` operations. */
  platformFederationGatewayClient: ReturnType<typeof useApolloClient>;
  publicFederationGatewayClient: ReturnType<typeof useApolloClient>;
};

const [useApolloClients, ApolloClientsContext] =
  createContext<ApolloClientsContext>({
    name: "ApolloClients",
  });

export { useApolloClients, ApolloClientsContext };
